import { ProductPageData } from '../../ApolloProvider/resolvers/Query/Product/ProductPage'
import { ProductImage } from '../../generated/graphql'

export const productGallery = (product: {
  title: string
  images: ProductImage[]
}) => {
  if (!product?.images?.length) {
    return null
  }

  return product.images.reduce<NonNullable<ProductPageData['gallery']>>(
    (accumulator, image) => {
      accumulator.thumbnails.push({
        url: image.thumbnail,
        alt: product.title,
        __typename: 'ProductGalleryImage',
      })
      accumulator.images.push({
        url: image.largeProduct
          ?.replace('/300', '/381')
          .replace('/300', '/533'),
        alt: product.title,
        __typename: 'ProductGalleryImage',
      })
      accumulator.zoom.push({
        url: image.zoom,
        alt: product.title,
        __typename: 'ProductGalleryImage',
      })
      return accumulator
    },
    {
      thumbnails: [],
      images: [],
      zoom: [],
      __typename: 'ProductGallery' as 'ProductGallery',
    },
  )
}
